import { render, staticRenderFns } from "./DangNhap.vue?vue&type=template&id=52009a59&"
import script from "./DangNhap.vue?vue&type=script&lang=js&"
export * from "./DangNhap.vue?vue&type=script&lang=js&"
import style0 from "./DangNhap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports